// components/Kpis.tsx
import DataCard from '../../../components/DataCard'
import Alert from '../../../components/Alert'

interface KpisProps {
    data: any | undefined;
    onCurrentBalanceClick?: () => void;
    onCashInClick?: () => void;
    onCashOutClick?: () => void;
}

export default function Kpis({ data, onCurrentBalanceClick, onCashInClick, onCashOutClick }: KpisProps) {

    if (!data) {
        return (
            <div className="dashboard-card">
                <Alert />
            </div>
        )
    }

    // Expecting formatted strings from API: current_balance, cash_in, cash_out, net_cash_flow
    return (
        <div data-tutorial="dashboard-kpis" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            <DataCard title={'Current Balance'} data={data.current_balance || '-'} onClick={onCurrentBalanceClick} tutorialAnchor="dashboard-kpi-primary" />
            <DataCard title={'Cash In'} data={data.cash_in || '-'} onClick={onCashInClick} />
            <DataCard title={'Cash Out'} data={data.cash_out || '-'} onClick={onCashOutClick} />
            <DataCard title={'Net Cash'} data={data.net_cash_flow || '-'} />
        </div>
    );
}
